export default {
  name: 'EventFormPartialView',

  props: {
    value: {
      type: Object,
      required: true
    },
    regions: {
      type: Array,
      required: true
    },
    types: {
      type: Array,
      required: true
    },
    $v: {
      type: Object,
      required: true
    },
    disableType: {
      type: Boolean
    },
    disableRegion: {
      type: Boolean
    },
    disableStartAndEndDate: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },

  computed: {
    regionOptions () {
      return this.regions.map((region) => {
        return {
          text: region.name,
          value: region.storeRegionID
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/EditEvent/EventForm.js